import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV } from '@fortawesome/pro-solid-svg-icons';

import ManagedInput from 'components/form/managed_input';
import { formatPercent, USD } from 'helpers/formatters/number_formats';

import './styles.scss';

export default function CompRow({ children, comp, connectDragSource, selected, onDeselect, onSelect }) {
  const details = [];
  if (comp.type === 'Research::Sale') {
    details.push(<div key="price">{USD.format(comp.price, { round: true })}</div>);
    details.push(<div key="size">{comp.buildingSizeLabel}</div>);

    if (comp.saleDate) {
      details.push(<div key="date">Sold {comp.saleDate}</div>);
    }

    if (comp.capRatePct != null) {
      details.push(<div key="capRate">Cap: {formatPercent(comp.capRatePct / 100)}</div>);
    }
  } else {
    details.push(<div key="price">{comp.leaseRateLabel}</div>);
    details.push(<div key="size">{comp.sizeLabel}</div>);

    if (comp.leaseDate) {
      details.push(<div key="date">Leased {comp.leaseDate}</div>);
    }
  }

  const selectable = onDeselect && onSelect;
  function handleClick() {
    if (selectable) {
      selected ? onDeselect(comp) : onSelect(comp);
    }
  }

  return (
    <div className={classNames('comp-row', { clickable: selectable })} onClick={handleClick}>
      <div className="row">
        <div className="col col-sm-6 col-xs-7">
          {connectDragSource && connectDragSource(
            <span className="drag-handle">
              <FontAwesomeIcon icon={faEllipsisV}/>
            </span>
          )}
          {selectable && <ManagedInput checked={selected} type="checkbox" />}
          <img className="hidden-sm hidden-xs" src={comp.photoUrl} />
          <div className="section">
            <div>{comp.displayName}</div>
            <div>{comp.displayName === comp.address ? comp.addressTwoLine[1] : comp.addressOneLine}</div>
            <div>{comp.propertyType}</div>
          </div>
        </div>

        <div className="col col-sm-4 hidden-xs">
          <div className="section">
            {details}
          </div>
        </div>

        <div className="controls col col-sm-2 col-xs-5">
          {children}
        </div>
      </div>
    </div>
  );
}

CompRow.propTypes = {
  children: PropTypes.node,
  comp: PropTypes.shape({
    address: PropTypes.string,
    addressOneLine: PropTypes.string,
    addressTwoLine: PropTypes.arrayOf(PropTypes.string).isRequired,
    buildingSizeLabel: PropTypes.string,
    capRatePct: PropTypes.number,
    displayName: PropTypes.string,
    leaseDate: PropTypes.string,
    leaseRateLabel: PropTypes.string,
    photoUrl: PropTypes.string,
    price: PropTypes.number,
    propertyType: PropTypes.string,
    saleDate: PropTypes.string,
    sizeLabel: PropTypes.string,
  }).isRequired,
  connectDragSource: PropTypes.func,
  selected: PropTypes.bool,
  onDeselect: PropTypes.func,
  onSelect: PropTypes.func,
};
